@if (completed) {
    <div class="pdf-content">
        @if (!completed.final) {
            <div class="not-final">
                <div>Concept</div>
            </div>
        }
        <div class="intro-header page-break-after">
            <div class="mb-1">
                <h2 class="h4 condensed">{{ completed.checklist_type.name }}</h2>
            </div>
            <div class="intro-info">
                <div class="intro-info-row">
                    <span class="intro-info-label">Werknummer</span>
                    <span class="intro-info-value">{{ completed.worknumber }}</span>
                </div>
                <div class="intro-info-row">
                    <span class="intro-info-label">Werkomschrijving</span>
                    <span class="intro-info-value pre-line">{{ completed.description }}</span>
                </div>
                <div class="intro-info-row">
                    <span class="intro-info-label">Adres / locatie</span>
                    <span class="intro-info-value">{{ completed.location }}</span>
                </div>
                <div class="intro-info-row">
                    <span class="intro-info-label">Uitvoerder</span>
                    <span class="intro-info-value">{{ completed?.executor?.name }}</span>
                </div>
                <div class="intro-info-row">
                    <span class="intro-info-label">Uitvoeringsdatum</span>
                    <span class="intro-info-value">{{
                        completed.executed_at ?? completed.created_at | date: 'd MMMM yyyy'
                    }}</span>
                </div>
            </div>
        </div>
        <div class="checklist-tables page-break-before">
            @for (questionGroup of questionGroups(); track $index) {
                <div class="question-group" [class.between-headers]="questionGroup.betweenHeaders">
                    @if (questionGroup.header; as headerQuestion) {
                        <app-checklist-question-pdf
                            #questionBlock
                            [question]="headerQuestion"
                            [answer]="questionAnswerMap.get(headerQuestion.id) ?? null"
                            [questionType]="headerQuestion.question_type"
                            [interactive]="interactive"
                            (signOff)="onSignOff($event)">
                        </app-checklist-question-pdf>
                    }

                    @for (question of questionGroup.questions; track question.id) {
                        <app-checklist-question-pdf
                            #questionBlock
                            [question]="question"
                            [answer]="questionAnswerMap.get(question.id) ?? null"
                            [questionType]="question.question_type"
                            [interactive]="interactive"
                            (signOff)="onSignOff($event)">
                        </app-checklist-question-pdf>
                    }
                </div>
            }
        </div>
        @if (completed.checklist_type.show_extra) {
            <div class="extra-tables page-break">
                <div class="mt-5 mb-1">
                    <h2 class="h4 condensed">Algehele indruk</h2>
                </div>
                <table class="excel-table">
                    <thead>
                        <tr>
                            <th class="excel-table-header">Positieve punten</th>
                            <th class="excel-table-header">Leerpunten</th>
                        </tr>
                    </thead>
                    <tr class="excel-table-row">
                        <td class="excel-table-data">
                            <ul>
                                @for (
                                    point of completed.points | filter: ChecklistPointType.positive : 'answer';
                                    track point
                                ) {
                                    <li [innerHTML]="point.comment | nl2br"></li>
                                }
                            </ul>
                        </td>
                        <td class="excel-table-data">
                            <ul>
                                @for (
                                    point of completed.points | filter: ChecklistPointType.learn : 'answer';
                                    track point
                                ) {
                                    <li [innerHTML]="point.comment | nl2br"></li>
                                }
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="extra-tables page-break">
                <div class="mt-5 mb-1">
                    <h2 class="h4 condensed">Actielijst</h2>
                </div>
                <table class="excel-table">
                    <thead>
                        <tr>
                            <th class="excel-table-header">Actiepunt</th>
                            <th class="excel-table-header">Door</th>
                            <th class="excel-table-header">Deadline</th>
                        </tr>
                    </thead>
                    @for (action of completed.actions; track action; let i = $index) {
                        <tr class="excel-table-row">
                            <td class="excel-table-data" [innerHTML]="action.action | nl2br"></td>
                            <td class="excel-table-data">
                                {{ action.user }}
                            </td>
                            <td class="excel-table-data">
                                {{ action.deadline | date: 'd MMM yyyy' }}
                            </td>
                        </tr>
                    }
                </table>
            </div>
        }
        <div class="accepted">
            @if (completed.accepted_kam) {
                <div>Geaccepteerd door KAM op {{ completed.accepted_kam_at | date: 'EEE d MMM yyyy HH:mm' }}</div>
            }
            @if (completed.accepted_management) {
                <div>
                    Geaccepteerd door Management op
                    {{ completed.accepted_management_at | date: 'EEE d MMM yyyy HH:mm' }}
                </div>
            }
        </div>
    </div>
}
